import ProgressBar from './ProgressBar.jsx';

export default ProgressBar;
